import React, { useMemo, useState, useEffect } from 'react'
import style from "./index.module.scss"
import Icon from 'components/Icon/Icon'
import wxQRCode from "assets/img/png/transocksWechat.png"
// import { LINKS } from 'store/ActionTypes'

const Footer = () => {
  const [year, setyear] = useState(2022)
  // const [links, setlinks] = useState([])

  useEffect(() => {
    const myDate = new Date()
    const nowYear = myDate.getFullYear()
    setyear(nowYear)
    // getFirendlyLinks()
  }, [])

  return useMemo(() => (
    <div className={style.footer}>
      <div className="container">
        {window.location.href.includes('source=tv') || <div className={style.top}>
          <div className={style.links}>
            <a href="/information.html?item=use-help" data-i18n="i.help">
              帮助中心
            </a>
            <a href="/information.html?item=contact-us" data-i18n="i.contact">
              联系我们
            </a>
            <a href="/information.html?item=terms">
              服务条款
            </a>
            <a href="/information.html?item=privacy" data-i18n="i.privacy">
              隐私条款
            </a>
            <a href="/information.html?item=cooperate" data-i18n="i.cooperative">
              合作推广
            </a>
          </div>
          {window.location.hostname !== 'www.transocks.org' && <div className={style.friendlyLink}>
            {/* <span >
              友情链接：
            </span>
            <a href="https://www.kongfuka.com/?channelKey=5fd8a8579f4342e5980b35eb27d3655d" rel="nofollow noopener noreferrer" target="_blank"  >
              点卡代充
            </a> */}

          </div>}
          <div className={style.icons}>
            <div className={style['icon-item'] + ' ' + style['icon-wechat']}>
              <a href="https://weixin.qq.com/r/UTmosH-E0SKurTvT92xD">
                <Icon
                  icon="iconicon_wechat"
                  className={style.icon}
                  fontSize="36"
                />
              </a>
              <div className={style['wechat-qr']}>
                <img src={wxQRCode} alt="wechat" />
                <span>Transocks</span>
              </div>
            </div>
            <div className={style['icon-item']}>
              <a
                href="https://url.cn/5c9hAmt?_type=wpa&qidian=true">
                <Icon
                  icon="iconicon_qq"
                  className={style.icon}
                  fontSize="36"
                />
              </a>
            </div>
            <div className={style['icon-item']}>
              <a href="mailto:transocks@qq.com">
                <Icon
                  icon="iconicon_mail"
                  className={style.icon}
                  fontSize="36"
                />
              </a>
            </div>
          </div>
        </div>}
        <div className={style.bottom}>
          <div className={style.logo}>
            穿梭Transocks
          </div>
          <div className={style.items}>
            <div className={style.itemsTop}>
              <div className={style.arr1}>
                <div className={style.copyright}>
                  Copyright <span role="img" aria-label="copyright"> ©️ </span> 2017-{year}
                </div>
                <div className={style.last}>
                  <a href="http://beian.miit.gov.cn">蜀ICP备 18024647号-1</a>
                </div>
              </div>
              <div className={style.arr2}>
                <div className={style.chuan}>
                  <img src="/img/beian.png" alt="" />
                  <a rel="nofollow noopener noreferrer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002002935">川公网安备 51019002002935号</a>
                </div>
                <div className={style.chuan}>
                  互联网虚拟专用网业务许可证 B1-20200386
                </div>
                <div className={style.last}>
                  增值电信业务经营许可证 川B2-20180414
                </div>

              </div>
            </div>
            {/* <div className={style.itemsBottom}>
              <div className={style.last}>
                增值电信业务经营许可证 川B2-20180414
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </div>
  ), [year])
}

export default Footer
